import { useContext } from 'react';

import { PricingEditionContext } from '..';

export const useIsPricingEditable = () => useContext(PricingEditionContext);
